import React, { Component } from 'react';
import axios from 'axios';
// import {Howl} from 'howler';
let playingAudio = null;
let timeOut = null;

// DEPRECATED : No longer used
const withContentsForDirectTranslation = () => (WrappedComponent) => {
    return class extends Component {
        state = {
            contents: null,
            soundRootURL: 'https://dev.itcenglish.com/contents/ts/sound', //test server
            playingIndex: 0,
            audioList: [],
            isPlaying: false,
            isPlayingComplete:false,
            c_code:null,
            isTesting: false,
            howlAudio:null,
        };

        componentDidMount(){
            this.initialize();
        }

        // componentWillUnmount() {
        //    this._audioStop();
        // }


        componentDidUpdate(prevProps, prevState){
            if(prevState.c_code !== this.state.c_code){
                this.setState({
                    contents:null,
                });
                this.initialize();
            }
        }

        static getDerivedStateFromProps (nextProps, prevState) {
            if(nextProps.c_code !== prevState.c_code){

                return({
                    c_code:nextProps.c_code
                })
            }

            return null;
        }


        initialize() {
            //console.log("Contents API URL: " + `${this.state.rootURL}/${this.props.lessonInfo.step_code}/${this.props.lessonInfo.lesson_no}/${this.state.c_code}`.replace(/\s/g, ''));
            Promise.all([
                //axios.get(`${this.state.rootURL}/${this.props.lessonInfo.step_code}/${this.props.lessonInfo.lesson_no}/${this.state.c_code}`),  //Contents
                //axios.get(`${this.props.apiUrl}/contents/${this.props.lessonInfo.step_code}/${this.props.lessonInfo.lesson_no}/${this.state.c_code}`),  //Contents
                //axios.get(`http://localhost:8080/menu/list/L1`), //MenuList
                axios({
                    method: 'get',
                    url: `${this.props.apiUrl}/contents/${this.props.lessonInfo.step_code}/${this.props.lessonInfo.lesson_no}/${this.state.c_code}`.replace(/\s/g, ''),
                })
            ])
                .then(([resContents]) => {
                    // //console.log("component will mount contents is:", res);
                    const contents = resContents.data;
                    this.setState({
                        ...this.state,
                        contents: contents,
                        //menuList,
                    });
                })
                .catch(function (err) {
                    //console.log(err);
                })
                .then(function () {

                });
        };

        render(){
            const { contents } = this.state;
            return(
                <WrappedComponent {...this.props}
                                  contents = {contents}
                                  // audioPause = {this._audioPause.bind(this)}
                                  // audioStop = {this._audioStop.bind(this)}
                                  // audioPlay = {this._audioPlay.bind(this)}
                                  // audioPlayAllTwice = {this._audioPlayAllTwice.bind(this)}
                                  // playingIndex = {this.state.playingIndex}
                                  // isPlaying = {this.state.isPlaying}
                                  // isPlayingComplete={this.state.isPlayingComplete}
                />
            )
        }
    }

};

export default withContentsForDirectTranslation;